import { Fragment, useEffect, useState } from 'react';
import Container from '../../../../core/components/atoms/Container';
import PageHeader from '../../../../core/components/molecules/Header';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Button } from '../../../../core/components/atoms/Button';
import { Icon } from '../../../../core/components/atoms/Icon';
import ContentLoader from 'react-content-loader';
import { useGetEssays } from '../../hooks/useGetEssays';
import { useEssayListStore } from '../../stores/essayListStore';
import { IEssayList } from '../../../../core/models/essay';
import { essayTitle } from '../../utils';
import ContentListCard from '../../../../core/components/organism/ContentListCard';
import { useNavigate } from 'react-router-dom';
import { Input } from '../../../../core/components/atoms/Input';
import { format } from 'date-fns';
import FilterEssay from './components/filter';
import { Tag } from '../../../../core/components/atoms/Tag';
import { meEssayStore } from '../../stores/meEssayStore';
import { useCredits } from '../../hooks/useCredits';
import { Alert } from '../../../../core/components/atoms/Alert';
import { Chip } from '../../../../core/components/atoms/Chip';
import { useEssayFilterStore } from '../../stores/essayFilterStore';
import { AboutMyEssaysModal } from './components/AboutMyEssaysModal';
import { MODAL_VIDEOS_VIMEO_ALLOWED } from '../../../../core/constants/modal-videos';
// import { BadgeScore } from '../../../../core/components/atoms/BadgeScore';

export default function MyEssays() {
  const navigate = useNavigate();
  const { isPending, mutate } = useGetEssays();
  const { essays } = useEssayListStore();
  useCredits();
  const { credits } = meEssayStore();
  const { reset } = useEssayFilterStore();

  const [searchName, setSearchName] = useState<string>('');
  const [data, setData] = useState<IEssayList[]>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [isMyEssaysModalOpen, setIsMyEssaysModalOpen] =
    useState<boolean>(false);

  useEffect(() => {
    mutate();
  }, []);

  useEffect(() => {
    setData(essays);
  }, [essays]);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      if (searchName && searchName.length > 0) {
        const filter = essays.filter((it) =>
          it.theme.toLowerCase().includes(searchName.toLowerCase())
        );

        setData(filter);
      } else {
        setData(essays);
      }
    }, 300);

    return () => clearTimeout(debounceTimeout);
  }, [searchName]);

  const handleURLFormat = (essay: IEssayList) => {
    if (essay.status === 'corrected' || essay.status === 'review') {
      return `/redacoes/correcao/${essay.slug}/${essay.tryNumber}`;
    }

    if (essay.status === 'sent') {
      return `/redacoes/aguardando/${essay.slug}?tryNumber=${essay.tryNumber}`;
    }

    return `/redacoes/start/${essay.slug}`;
  };

  const statusConfig = (status: string, addon?: Date | null) => {
    switch (status) {
      case 'writing':
        return {
          icon: 'save_as',
          translate: 'Redação salva',
          color: 'red',
          subtitle: 'Não enviado',
        };
      case 'corrected': {
        const dataCorrected =
          addon && addon !== undefined
            ? format(new Date(addon || ''), 'dd/MM/yyyy')
            : '';

        return {
          icon: 'done',
          translate: 'Corrigida',
          color: 'green',
          subtitle: `Corrigida em: ${dataCorrected}`,
        };
      }
      case 'review': {
        const dataCorrected =
          addon && addon !== undefined
            ? format(new Date(addon || ''), 'dd/MM/yyyy')
            : '';

        return {
          icon: 'done',
          translate: 'Corrigida',
          color: 'green',
          subtitle: `Corrigida em: ${dataCorrected}`,
        };
      }
      case 'sent': {
        const dataSent =
          addon && addon !== undefined
            ? format(new Date(addon || ''), 'dd/MM/yyyy')
            : '';

        return {
          icon: 'schedule_send',
          translate: 'Aguardando correção',
          color: 'yellow',
          subtitle: `Enviada em: ${dataSent}`,
        };
      }
      default:
        return {
          icon: 'save_as',
          translate: 'Redação salva',
          color: 'red',
          subtitle: 'Não enviada',
        };
    }
  };

  const submitFilter = () => {
    mutate();
    setIsOpen(false);
  };

  //TODO: Dividir em componentes onde possivel
  //TODO: Componente de small screen pode ser compartilhado com o theme
  return (
    <Container
      gap='xxl'
      direction='col'
      type='updated'
      className='xs:mb-[30px] xl:mb-[30px]'
    >
      <FilterEssay
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmit={() => submitFilter()}
      />
      <div className='flex w-full flex-col xs:justify-start xs:max-lg:items-start xs:max-lg:gap-lg lg:justify-between'>
        <div className='flex w-full flex-col gap-4  xs:max-lg:items-start md:flex-row md:items-center'>
          <PageHeader title='Minhas Redações' module='Redação' />
          {MODAL_VIDEOS_VIMEO_ALLOWED.MINHAS_REDACOES.allowed && (
            <Button
              variant='text'
              LeftIcon='info'
              iconType='material'
              iconSize='small'
              className='hidden flex-none whitespace-nowrap p-0 text-center text-md md:flex md:text-md'
              onClick={() => setIsMyEssaysModalOpen(true)}
            >
              Como funciona
            </Button>
          )}
          <AboutMyEssaysModal
            isOpen={isMyEssaysModalOpen}
            onClose={() => setIsMyEssaysModalOpen(false)}
          />
        </div>
        <div className='flex flex-row items-center justify-end gap-lg'>
          {/* <BadgeScore score={[1, 2]} /> */}
          <Tag
            variant={
              credits?.remainingCreditsMonth &&
              credits?.remainingCreditsMonth > 0
                ? 'white'
                : 'alert'
            }
            className='inline-flex h-fit w-fit items-center gap-sm px-3 py-[3px]'
          >
            <Icon
              Icon='folder'
              type='material'
              className='text-[14px] text-mono-color-darkest'
            />
            <Typography>
              {credits?.remainingCreditsMonth} créditos disponíveis
            </Typography>
          </Tag>
          <Button
            className='xs:hidden lg:block'
            onClick={() => navigate('/redacoes/temas')}
          >
            <div className='flex flex-row items-center gap-sm'>
              <Icon
                Icon='edit'
                type='material'
                variant='rounded'
                className='text-white text-lg'
              />
              Escrever redação
            </div>
          </Button>
        </div>
      </div>
      {MODAL_VIDEOS_VIMEO_ALLOWED.MINHAS_REDACOES.allowed && (
        <Button
          variant='text'
          LeftIcon='info'
          iconType='material'
          iconSize='small'
          className='flex-none whitespace-nowrap p-0 text-md md:hidden md:text-md'
          onClick={() => setIsMyEssaysModalOpen(true)}
        >
          Como funciona
        </Button>
      )}
      {credits?.remainingCreditsMonth === 0 && (
        <Alert
          variant='warning'
          message={
            <Typography className='my-1'>
              Atenção: Você não possui créditos disponíveis para enviar
              redações.
              <strong>
                {' '}
                Seus créditos serão renovados no inicio de cada mês{' '}
              </strong>
            </Typography>
          }
        />
      )}
      <div className='flex h-fit w-full flex-row items-center justify-between'>
        <Input
          className='xs:w-2/3 lg:w-1/3'
          onChange={(e) => setSearchName(e.target.value)}
          value={searchName}
          label='Encontrar tema'
          IconLeft={{
            Icon: 'search',
            type: 'material',
            className: 'text-mono-color-dark',
          }}
        />
        <div>
          <Button
            variant='text'
            onClick={() => setIsOpen(true)}
            className='p-0'
          >
            <Icon
              Icon='filter_list'
              type='material'
              className='xs:text-sm md:text-md'
            />
            <span className='xs:text-sm md:text-md'>Filtrar redações</span>
          </Button>
        </div>
      </div>
      {isPending ? (
        <div className='grid w-full gap-md xs:grid-cols-1 lg:grid-cols-3 xl:grid-cols-4'>
          {Array.from({ length: 10 }, (_, key) => (
            <div key={key}>
              <ContentLoader
                backgroundColor={'#a7adba'}
                foregroundColor={'#c0c5ce'}
                viewBox='0 0 600 500'
              >
                <rect x='0' y='10' rx='2' ry='2' width='600' height='700' />
              </ContentLoader>
            </div>
          ))}
        </div>
      ) : (
        <Fragment>
          <div className='w-full gap-md xs:hidden xs:grid-cols-1 lg:grid lg:grid-cols-3 xl:grid-cols-4'>
            {data.map((it, i) => {
              const addon =
                it.status === 'sent'
                  ? it.updatedAt
                  : it.status === 'corrected' || it.status === 'review'
                    ? it.correctedAt
                    : null;

              return (
                <ContentListCard
                  key={i}
                  text={it.theme}
                  subtext={statusConfig(it.status, addon).subtitle}
                  onClick={() => {
                    reset();
                    navigate(handleURLFormat(it));
                  }}
                  tags={[
                    {
                      text: essayTitle(it.correctionType),
                      color: 'bg-mono-color-lighter',
                    },
                  ]}
                  imageBackground={it.thumbnail}
                  hasBand={true}
                  band={
                    <div className='flex w-full flex-row items-center justify-between'>
                      <div className='flex w-fit flex-row items-center gap-sm'>
                        <Icon
                          Icon={statusConfig(it.status).icon}
                          type='material'
                          variant='rounded'
                          className='text-md'
                        />
                        <Typography
                          weight='bold'
                          size='small'
                          className={`${it.status === 'sent' ? 'text-card-color-negative' : 'text-card-color-default'}`}
                        >
                          {statusConfig(it.status).translate}
                        </Typography>
                      </div>
                      {(it.status === 'corrected' || it.status === 'review') &&
                        it.finalScore > 0 && (
                          <Typography
                            size='small'
                            weight='bold'
                            className='text-card-color-default'
                          >
                            nota{' '}
                            {Number.isInteger(it.finalScore)
                              ? it.finalScore.toString()
                              : it.finalScore.toFixed(2).toString()}
                          </Typography>
                        )}
                      {(it.status === 'corrected' || it.status === 'review') &&
                        it.finalScore === 0 && (
                          <Typography
                            size='small'
                            weight='bold'
                            className='text-card-color-default'
                          >
                            nota 0
                          </Typography>
                        )}
                    </div>
                  }
                  color={
                    statusConfig(it.status).color as
                      | 'yellow'
                      | 'red'
                      | 'green'
                      | 'default'
                      | undefined
                  }
                />
              );
            })}
          </div>
          <div className='w-full flex-col gap-md xs:mb-0 xs:flex sm:mb-20 lg:hidden'>
            {data.map((it, i) => {
              const addon =
                it.status === 'sent'
                  ? it.updatedAt
                  : it.status === 'corrected'
                    ? it.correctedAt
                    : null;

              return (
                <div
                  key={i}
                  className='flex cursor-pointer flex-col gap-lg rounded-md bg-color-lightest p-4'
                  onClick={() => navigate(handleURLFormat(it))}
                >
                  <div className='flex flex-row items-center justify-between'>
                    <div className='inline-flex gap-sm'>
                      <Chip
                        variant='negative'
                        className={`shadow-level-none px-2`}
                      >
                        {essayTitle(it.correctionType)}
                      </Chip>
                      {it.axis && (
                        <Chip
                          variant='negative'
                          className={`shadow-level-none px-2`}
                        >
                          {it.axis.title}
                        </Chip>
                      )}
                    </div>
                    <Icon
                      Icon={statusConfig(it.status).icon}
                      type='material'
                      variant='rounded'
                      className={`text-lg text-mono-color-dark`}
                    />
                  </div>
                  <Typography type='title' size='h5'>
                    {it.theme}
                  </Typography>
                  <div className='flex flex-row items-center justify-between'>
                    <Typography size='mini' className='italic'>
                      {statusConfig(it.status, addon).subtitle}
                    </Typography>
                    {it.status !== 'corrected' ? (
                      <Typography size='mini' weight='bold'>
                        {statusConfig(it.status).translate}
                      </Typography>
                    ) : (
                      <div className='inline-flex items-center gap-sm'>
                        <Typography size='mini' weight='bold'>
                          nota
                        </Typography>
                        <Typography size='h4' weight='bold'>
                          {it.finalScore}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </Fragment>
      )}
    </Container>
  );
}
